import { isElementNode, isOneOfTags } from 'anodum';
import {
  ALTERNATIVE_BOLD,
  ALTERNATIVE_ITALIC,
  BOLD_TAG,
  ITALIC_TAG,
} from '../constants/editable-elements';

const isRolledBackTagByStyle = (element) => {
  if (!isElementNode(element)) return false;

  const { fontWeight, fontStyle } = element.style;
  const isBoldTag = isOneOfTags(element, [BOLD_TAG, ...ALTERNATIVE_BOLD]);
  if (isBoldTag && (fontWeight === 'normal' || (fontWeight !== '' && fontWeight <= 400)))
    return true;

  const isItalicTag = isOneOfTags(element, [ITALIC_TAG, ...ALTERNATIVE_ITALIC]);
  return isItalicTag && fontStyle === 'normal';
};

export default isRolledBackTagByStyle;
